export class FiltersOptionsModel {
  locations: LocationFilterOption[] = [];
  timePeriods: TimePeriodFilterOption[] = [];
  daysOfWeek: DayOfWeekFilterOption[] = [];
  requestedStaff: RequestedStaffFilterOption[] = [];
  assistedBy: AssistedByFilterOption[] = [];
  supervisors: SupervisorFilterOption[] = [];
  categories: CategoryFilterOption[] = [];
  services: ServiceFilterOption[] = [];
  statuses: StatusFilterOption[] = [];
  assistTypes: AssistTypeFilterOption[] = [];
  defaultViews: ViewFilterOption[] = [];
  users: UserFilterOption[] = [];
  autoWrapUpStatus: AutoWrapUpStatusFilterOption[] = [];
  shareableUsers: UserFilterOption[] = [];
  shareablePermissionGroups: PermissionGroupFilterOption[] = [];
  selectedLocations: LocationFilterOption[] = [];
  selectedTimePeriod: TimePeriodFilterOption[] = [];
  selectedDaysOfWeek: DayOfWeekFilterOption[] = [];
  selectedRequestedStaff: RequestedStaffFilterOption[] = [];
  selectedAssistedBys: AssistedByFilterOption[] = [];
  selectedSupervisors: SupervisorFilterOption[] = [];
  selectedCategories: CategoryFilterOption[] = [];
  selectedServices: ServiceFilterOption[] = [];
  selectedStatuses: StatusFilterOption[] = [];
  selectedAssistTypes: AssistTypeFilterOption[] = [];
  selectedViews: ViewFilterOption[] = [];
  selectedAutoWrapUpStatus: AutoWrapUpStatusFilterOption[] = [];
  selectedUsers: UserFilterOption[] = [];
  searchTerms: SearchTermsFilterOption[] = [];
  //selectedSearchTerms: SearchTermsFilterOption[];
  filteredServices: ServiceFilterOption[] = [];
  filteredAssistedBys: AssistedByFilterOption[] = [];
  filteredUsers: UserFilterOption[] = [];
  isDefault: IsDefaultOption = { value: false };
  sharedUsers: UserFilterOption[] = [];
  sharedPermissionGroups: PermissionGroupFilterOption[] = [];
  constructor() {
    //this.locations = new Array<LocationFilterOption>();
    //this.timePeriods = new Array<TimePeriodFilterOption>();
  }
}
export interface LocationFilterOption {
  locationId: number;
  code: string;
  locationName: string;
}
export interface TimePeriodFilterOption {
  detailViewTimePeriodId: number;
  timePeriodName: string;
}
export interface DayOfWeekFilterOption {
  dayOfWeek: number;
  dayOfWeekName: string;
  localizedDayOfWeekName?: string;
}
export interface RequestedStaffFilterOption {
  staffId: number;
  code: string;
  staffFullname: string;
  localizedStaffFullname?: string;
  isNotificationGroup?: boolean;
}
export interface AssistedByFilterOption {
  staffId: number;
  code: string;
  staffFullname: string;
  staffSupervisorsId: number;
  supervisorCode: string;
  isSupervisor: boolean;
  isNotificationGroup?: boolean;
}
export interface SupervisorFilterOption {
  staffId: number;
  code: string;
  staffFullname: string;
  localizedStaffFullname?: string;
}
export interface CategoryFilterOption {
  categoryId: number;
  code: string;
  categoryName: string;
}
export interface ServiceFilterOption {
  serviceId: number;
  code: string;
  serviceName: string;
  categoryId: number;
  categoryName: string;
  categoryCode: string;
}
export interface StatusFilterOption {
  lobbyStatusId: number;
  statusName: string;
  localizedStatusName?: string;
}
export interface AssistTypeFilterOption {
  assistTypeId: number;
  assistTypeName: string;
  localizedAssistTypeName?: string;
}
export interface ViewFilterOption {
  viewId: number;
  viewName: string;
  viewLocalizedName?: string;
}
export interface AutoWrapUpStatusFilterOption {
  autoWrapUpStatusId: number;
  autoWrapUpStatus: string;
  localizedAutoWrapUpStatus?: string;
}
export interface SearchTermsFilterOption {
  detailViewSearchTermId: number;
  searchTerm: string;
}
export interface IsDefaultOption {
  value: boolean;
}
export interface UserFilterOption {
  staffId: number;
  code: string;
  staffFullname: string;
}
export interface PermissionGroupFilterOption {
  permissionGroupId: number;
  permissionGroupName: string;
}
